// src/components/Layout/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerStyle = {
    borderTop: '1px solid #eee',
    padding: '20px',
    marginTop: '40px',
    textAlign: 'center',
    fontSize: '0.9em',
    color: '#666',
  };

  const linkStyle = {
    color: '#2980B9',
    textDecoration: 'none',
    margin: '0 10px',
  };

  return (
    <footer style={footerStyle}>
      <div>
        <Link to="/about" style={linkStyle}>About</Link>
        <Link to="/terms" style={linkStyle}>Terms of Service</Link>
        <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>
      </div>
      <div style={{ marginTop: '10px' }}>
        © {new Date().getFullYear()} cisfuss. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;